"use strict";
var hlp = require('common/helpers');
var parseGeolocation = require('common/validators').parseGeolocation;
var validate = require('common/validators').validate;
var fieldCtrl = function($scope, $attrs, $parse) {
  var ctrl = this;
  var init = function() {
    var name = $parse($attrs.name)($scope);
    $scope.name = name;
    if (name && $scope.data && $scope.data[name]) {
      initData();
    }
    $scope.$watch('data', function() {
      initData();
    });
  };
  var initData = function() {
    $scope.type = $scope.data[$scope.name].schema.type;
    $scope.readonly = $scope.readonly || $scope.data[$scope.name].schema.readonly;
    $scope.entries = $scope.data[$scope.name].entries;
    $scope.schema = $scope.data[$scope.name].schema;
    if ($scope.readonly) {
      $scope.template = 'default';
    } else {
      switch ($scope.type) {
        case 'image':
          $scope.template = 'image';
          break;
        case 'bildnr':
          $scope.template = 'bildnr';
          initEntry();
          break;
        case 'text':
          $scope.template = 'text';
          initEntry();
          break;
        default:
          $scope.template = 'default';
          initEntry();
          break;
      }
    }
  };
  var initEntry = function() {
    if (!$scope.entries || $scope.entries.length == 0) {
      $scope.addEntry();
    }
  };
  $scope.addEntry = function() {
    $scope.entries.push({value: ""});
  };
  $scope.removeEntry = function(entry, min) {
    if (!hlp.isSet(min)) {
      min = 1;
    }
    if ($scope.entries.length > min) {
      var index = $scope.entries.indexOf(entry);
      $scope.entries.splice(index, 1);
    } else if ($scope.entries.length == 1) {
      $scope.entries.pop();
      $scope.addEntry();
    }
  };
  $scope.getPlaceholder = function() {
    switch ($scope.type) {
      case "geolocation":
        return "<Latitude> <Longitude>";
      default:
        return null;
    }
  };
  $scope.getLinkUrl = function(entry) {
    var latlng = parseGeolocation(entry.value);
    if (!latlng)
      return null;
    return "http://www.openstreetmap.org/?mlat=" + latlng[0] + "&mlon=" + latlng[1];
  };
  $scope.validate = function(schema, entry) {
    return validate(schema, entry);
  };
  init();
};
fieldCtrl.$inject = ['$scope', '$attrs', '$parse'];
module.exports = fieldCtrl;
